import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
} from "react";

const LayoutChromeContext = createContext(null);

/**
 * Tiny bus so mobile Sidebar overflow menu can open Navbar-owned modals
 * without duplicating modal state or ABAC gates in two places.
 */
export function LayoutChromeProvider({ children }) {
  const apiRef = useRef({});

  const register = useCallback((partial) => {
    apiRef.current = { ...apiRef.current, ...partial };
    return () => {
      Object.keys(partial || {}).forEach((key) => {
        if (apiRef.current[key] === partial[key]) {
          delete apiRef.current[key];
        }
      });
    };
  }, []);

  const call = useCallback((name, ...args) => {
    const fn = apiRef.current?.[name];
    if (typeof fn === "function") fn(...args);
  }, []);

  const value = useMemo(() => ({ register, call }), [register, call]);

  return (
    <LayoutChromeContext.Provider value={value}>
      {children}
    </LayoutChromeContext.Provider>
  );
}

export function useLayoutChrome() {
  return useContext(LayoutChromeContext);
}

export default LayoutChromeContext;
